import { staticFile } from '@common/utils'
import { LazyImage } from './image'

const TestimonialCard = ({ imageUrl, name, content, role }) => (
  <div className="flex relative flex-col justify-center p-10 mx-8 mt-32 max-w-sm bg-white rounded-lg shadow-lg lg:h-64 lg:mt-20 lg:mx-20">
    <img
      src={staticFile('/images/book-trial-class/shape-1.svg')}
      className="absolute top-0 left-0 -mt-5 ml-5 h-8 lg:h-12"
      alt="Background Vector Shape"
      loading="lazy"
    />
    <img
      src={staticFile('/images/book-trial-class/shape-2.svg')}
      className="hidden absolute top-0 right-0 -mt-5 mr-5 h-12 lg:flex"
      alt="Background Vector Shape"
      loading="lazy"
    />
    <img
      src={staticFile('/images/book-trial-class/shape-3.svg')}
      className="hidden absolute bottom-0 left-0 -mb-5 -ml-5 h-20 lg:flex"
      alt="Background Vector Shape"
      loading="lazy"
    />
    <img
      src={staticFile('/images/book-trial-class/shape-4.svg')}
      className="hidden absolute right-0 bottom-0 -mr-5 -mb-5 h-12 lg:flex"
      alt="Background Vector Shape"
      loading="lazy"
    />
    <LazyImage
      path={imageUrl}
      name={name}
      className="absolute top-0 right-1/2 -mt-24 -mr-24 w-40 lg:top-1/2 lg:right-0"
      alt={role}
    />
    <p className="mt-20 text-center text-grey lg:text-left lg:mr-10 lg:mt-0">
      {content}
    </p>
    <p className="mt-5 text-sm text-center font-600 lg:text-left">- {role}</p>
  </div>
)

export default TestimonialCard
